import styled, { css } from "styled-components";
import { colors, colorsHover, colorsFont } from "../../styles/colors";
import loaderLight from "../../assets/loader/light.png";

export const ButtonContainer = styled.div`
  & > label {
    display: block;
    min-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
`;

interface StyledButtonProps {
    $color: string;
    $isLoading?: boolean;
}

export const StyledButton = styled.button<StyledButtonProps>`
  border-radius: 2px;
  font-weight: 600;
  height: fit-content;
  min-height: 34px;
  min-width: fit-content;
  position: relative;
  transition: background-color 0.3s, color 0.3s;
  width: 100%;
  border: none;
  cursor: pointer;

  /* Default or dynamic color styles */
  ${({ $color }) => {
        // Map the incoming color string (e.g. "primary", "primary--light") to the keys in our colors object
        // The SCSS used classes like ".--primary", so we expect input like "primary"
        // We handle the dot and dash conventions.
        const cleanColor = $color.replace(/^\.--/, "").replace(/^--/, ""); // Normalize "primary", ".--primary", "primary--light" to match keys if possible

        // Actually the types say 'primary', 'primary--light' etc.
        // colors object keys are 'primary', 'primaryLight' (camelCase).
        // The previous SCSS map had keys like ".--primary--light".
        // We need a helper or just mapping.

        let colorKey = cleanColor;
        if (cleanColor === "primary--light") colorKey = "primaryLight";
        if (cleanColor === "primary--dark") colorKey = "primaryDark";
        if (cleanColor === "secondary--dark") colorKey = "secondaryDark";
        if (cleanColor === "unabled--dark") colorKey = "unabledDark";

        const bgColor = (colors as any)[colorKey];
        const hoverColor = (colorsHover as any)[colorKey];
        const fontColor = (colorsFont as any)[colorKey];

        if (bgColor) {
            return css`
        background-color: ${bgColor};
        color: ${fontColor || "white"};

        &:hover {
          background-color: ${hoverColor || bgColor};
        }
      `;
        }
        return css``;
    }}

  &:disabled {
    background: ${colors.unabled};
    color: ${colorsFont.unabled};
    pointer-events: none;
  }

  ${({ $isLoading }) =>
        $isLoading &&
        css`
      background-color: ${colors.unabled};
      pointer-events: none;
      color: transparent; /* Hide text */

      &::before {
        background: url(${loaderLight}) no-repeat center / cover;
        content: "";
        height: 30px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
      }
    `}
`;
